const _ = require('lodash')
const orders = require('./orders/customerOrders')
const incidents = require('./incidents/incidents')
const vehicles = require('./user/vehicles')
const partners = require('./user/partners')
const drivers = require('./user/drivers')
const stores = require('./user/stores')
const schedules = require('./filters/schedules')
const storesFilters = require('./filters/stores')
const sortOrders = require('./filters/sortOrders')
const sortEdf = require('./filters/sortEdf')

const SCHEMAS = {
  orders,
  incidents,
  vehicles,
  partners,
  drivers,
  stores,
  schedules,
  storesFilters,
  sortOrders,
  sortEdf
}

const _deepPick = (payload, json) => {
  if (_.isArray(payload)) {
    return payload.map(item => _deepPick(item, json))
  }

  const object = _.pick(payload, _.keys(json))
  return object
}

export const stripPayload = (payload, schema) => {
  return _deepPick(payload, SCHEMAS[schema])
}



// WEBPACK FOOTER //
// ./src/schemas/index.js